import toast from 'react-hot-toast';

export const STATUS_CONFIG = {
  todo: { label: 'To Do', color: 'bg-slate-100 text-slate-700', dot: 'bg-slate-400' },
  in_progress: { label: 'In Progress', color: 'bg-blue-100 text-blue-700', dot: 'bg-blue-500' },
  completed: { label: 'Completed', color: 'bg-emerald-100 text-emerald-700', dot: 'bg-emerald-500' },
  on_hold: { label: 'On Hold', color: 'bg-amber-100 text-amber-700', dot: 'bg-amber-500' },
  reopened: { label: 'Reopened', color: 'bg-orange-100 text-orange-700 dark:bg-orange-950/40 dark:text-orange-400', dot: 'bg-orange-500' },
};

export const PRIORITY_CONFIG = {
  low:      { label: 'Low',      color: 'bg-slate-100 text-slate-600',  iconName: 'ArrowDownIcon',  iconColor: '#64748b' },
  medium:   { label: 'Medium',   color: 'bg-amber-100 text-amber-700',  iconName: 'MinusIcon',      iconColor: '#d97706' },
  high:     { label: 'High',     color: 'bg-orange-100 text-orange-700',iconName: 'ArrowUpIcon',    iconColor: '#ea580c' },
  critical: { label: 'Critical', color: 'bg-red-100 text-red-700',      iconName: 'BoltIcon',       iconColor: '#dc2626' },
};

export const ROLE_CONFIG = {
  admin: { label: 'Admin', color: 'bg-brand-100 text-brand-700' },
  user: { label: 'User', color: 'bg-slate-100 text-slate-600' },
};

export const formatDate = (date) => {
  if (!date) return '—';
  return new Date(date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const formatDateTime = (date) => {
  if (!date) return '—';
  return new Date(date).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export const isOverdue = (deadline, status) => {
  if (!deadline || status === 'completed') return false;
  return new Date(deadline) < new Date();
};

export const getInitials = (name = '') =>
  name.split(' ').map((n) => n[0]).join('').toUpperCase().slice(0, 2);

export const AVATAR_COLORS = [
  'bg-brand-500', 'bg-emerald-500', 'bg-amber-500', 'bg-rose-500',
  'bg-cyan-500', 'bg-violet-500', 'bg-pink-500', 'bg-teal-500',
];

export const getAvatarColor = (str = '') => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

export const resolveFileUrl = (url) => {
  if (!url) return '';
  const rawUrl = typeof url === 'string' ? url : (url.fileUrl || url.url || '');
  if (!rawUrl) return '';

  if (rawUrl.startsWith('data:')) return rawUrl;

  const backendOrigin = (process.env.REACT_APP_API_URL || '').replace(/\/api\/?$/, '') || window.location.origin;

  // 1. If it's already an absolute URL (starts with http/https)
  if (rawUrl.startsWith('http://') || rawUrl.startsWith('https://')) {
    if (rawUrl.includes('/uploads/') && !rawUrl.includes('/api/uploads/')) {
      return rawUrl.replace('/uploads/', '/api/uploads/');
    }
    return rawUrl;
  }

  // 2. If it's a relative path containing /api/uploads/
  const apiUploadsIdx = rawUrl.indexOf('/api/uploads/');
  if (apiUploadsIdx !== -1) {
    const relPath = rawUrl.substring(apiUploadsIdx);
    return `${backendOrigin}${relPath}`;
  }

  // 3. If it's a relative path containing /uploads/
  const uploadsIdx = rawUrl.indexOf('/uploads/');
  if (uploadsIdx !== -1) {
    const relPath = rawUrl.substring(uploadsIdx);
    return `${backendOrigin}/api${relPath}`;
  }

  return rawUrl;
};

export const handleDownloadFile = async (rawUrl, originalName) => {
  const url = resolveFileUrl(rawUrl);
  if (!url) {
    toast.error('Invalid file URL');
    return;
  }
  try {
    const res = await fetch(url, { method: 'GET' });
    if (!res.ok) {
      toast.error('Attachment file not found on server (it may have been deleted or uploaded in another session)');
      return;
    }
    const contentType = res.headers.get('content-type') || '';
    if (contentType.includes('application/json') || contentType.includes('text/html')) {
      toast.error('Attachment file not found on server');
      return;
    }
    const blob = await res.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = originalName || 'attachment';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  } catch (err) {
    window.open(url, '_blank');
  }
};


